<script lang="ts">
    export let value: any,
        id,
        classList: string = "",
        onChange: (e: Event) => void,
        type: "password" | "text" | "number" | "checkbox" | "noInput" = "text",
        placeholder: string = "",
        disabled: boolean = false
    $: hasValue = Boolean(value)

    const attributes = {
        id,
        class: classList,
        placeholder,
        name: id,
        disabled: !!disabled,
    }
</script>

<label style="">
    {#if type !== "checkbox"}
        <span class:hasValue="{hasValue || type === 'noInput'}">{placeholder}</span>
    {/if}
    {#if type == "checkbox"}
        <input
            type="checkbox"
            {...attributes}
            on:change="{onChange}"
            bind:checked="{value}"
        />
        <button
            type="button"
            class="checkit-span"
            tabindex="{3}"
            on:click="{() => {
                value = !value
                setTimeout(() => {
                    const event = new Event('change', { bubbles: true })
                    document.getElementById(id)?.dispatchEvent(event)
                }, 10)
            }}"
            on:keydown="{(e) => {}}"></button>
    {/if}
    {#if type == "password"}
        <input
            {...attributes}
            on:blur="{onChange}"
            bind:value="{value}"
            on:change="{onChange}"
        />
    {/if}
    {#if type == "text"}
        <input
            on:blur="{onChange}"
            {...attributes}
            bind:value="{value}"
            on:change="{onChange}"
        />
    {/if}
    {#if type == "number"}
        <input
            on:blur="{onChange}"
            type="number"
            {...attributes}
            bind:value="{value}"
            on:change="{onChange}"
        />
    {/if}
    {#if type == "noInput"}
        <div class="no-input">
            {#if id.includes("pass")}
                ************
            {:else}
                {Boolean(value) ? value : "-"}
            {/if}
        </div>
    {/if}
</label>

<style lang="less">
</style>
